export default __webpack_public_path__ + "static/media/1018.2ac8b7f9.png";